import { useParams } from 'react-router-dom'

import { useGetSpotifyPaymentSettingsQuery } from 'src/Redux/artistPaymentSettingsApi'
import {
  useGetMatchedCuratorsQuery,
  MatchedCuratorsSortBy,
} from 'src/Redux/matchedCuratorsApi'
import { useSpotifyCampaignStatus } from 'src/Redux/spotifyCampaignStatusApi'

import { getIsLanguageActive } from '../helpers/helpers'

import {
  getAreMatchedCuratorsBelowMinBudget,
  MATCHED_CURATORS_PAGE_SIZE,
} from './helper'

const FIRST_PAGE = 1

export const useAreMatchedCuratorsBelowMinBudget = (
  isEnabled: boolean,
): boolean => {
  const params = useParams()
  const id = params.number
  const { campaignDetails } = useSpotifyCampaignStatus()

  const genres = campaignDetails?.genres ?? []
  const languages = campaignDetails?.languages ?? []
  const isSettingsReady =
    Boolean(genres.length) && !getIsLanguageActive(languages)

  const { data: curatorsList, isFetching } = useGetMatchedCuratorsQuery(
    {
      campaignId: id ?? '',
      pageNumber: FIRST_PAGE,
      pageSize: MATCHED_CURATORS_PAGE_SIZE,
      sortBy: MatchedCuratorsSortBy.BEST_MATCH,
    },
    { skip: !isEnabled || !id || !isSettingsReady },
  )

  const {
    data: spotifyPaymentSettings,
    isSuccess: isMinBudgetLoaded,
    isLoading: isMinBudgetLoading,
  } = useGetSpotifyPaymentSettingsQuery(void 0, {
    refetchOnMountOrArgChange: true,
    skip: !isEnabled,
  })

  if (isFetching || isMinBudgetLoading) {
    return false
  }

  return getAreMatchedCuratorsBelowMinBudget(
    curatorsList,
    isMinBudgetLoaded
      ? spotifyPaymentSettings?.manualMatchingMinBudget
      : void 0,
  )
}
